/*
 * @Author: 刘洪壮 liuhongzhuang@nextmar.com
 * @Date: 2025-07-02 11:46:42
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-07-17 18:36:11
 * @FilePath: /src/app/payment/components/Address/components/ChooseAddress/AddressCard.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

import { Address, Country } from '@/api/types/public';
import Radio from '@/components/Form/Radio';
import Image from '@/components/Image';
import { getAddressRules, getErrorTranslationKey } from '@/utils/form-rule';
import { useTranslations } from 'next-intl';
import { useState } from 'react';
import { useForm } from 'react-hook-form';

interface AddressCardProps {
  address: Address;
  shippingAddress?: Address;
  paymentType?: string;
  isBilling?: boolean;
  countryList: Country[];
  onEditClick: (address: Address) => void;
  onChooseAddress: (address: Address) => void;
}

export default function AddressCard({
  address,
  shippingAddress,
  paymentType,
  isBilling = false,
  countryList,
  onEditClick,
  onChooseAddress,
}: AddressCardProps) {
  const taxTipsShow = (_address: Address) => {
    let flag = false;
    if (_address.country_id === 'BR' && !_address.cpf) {
      flag = true;
    }
    return flag;
  };

  const disabledAddressItem = (_address: Address) => {
    const rule1 = ['afterpay', 'klarna'].includes(paymentType);
    const rule2 = _address.country_id !== shippingAddress?.country_id;
    return rule1 && rule2;
  };

  const { control } = useForm();

  const tValidation = useTranslations('components.address.validation');
  const t = useTranslations('payment.address');

  const countryInvalid = (_address: Address) => {
    let flag = false;
    if (_address.status === 2) {
      flag = true;
    }
    return flag;
  };

  const [checked, setChecked] = useState(false);

  const handleCheckboxChange = () => {
    setChecked(!checked);
    onChooseAddress(address);
  };

  // 计算姓名和电话的总字符长度
  const getTotalNamePhoneLength = () => {
    const fullName = `${address.firstname || ''} ${address.lastname || ''}`.trim();
    const phone = address.telephone || '';
    return fullName.length + phone.length;
  };

  // 判断是否需要使用非加粗样式
  const shouldUseNormalWeight = getTotalNamePhoneLength() > 26;

  const errorCode = getAddressRules(address, countryList);

  const errorMsg =
    errorCode && getErrorTranslationKey(errorCode)
      ? tValidation(getErrorTranslationKey(errorCode)!)
      : '';

  return (
    <div className="bg-white px-12 py-22 mb-10 rounded-[6px]">
      <Radio
        name="address"
        control={control}
        disabled={
          !address.checked ||
          (isBilling ? disabledAddressItem(address) : taxTipsShow(address)) ||
          countryInvalid(address)
        }
        sx={{
          width: '100%',
          margin: 0,
          '& .MuiFormControlLabel-root': {
            width: '100%',
            flexGrow: 1,
            maxWidth: '100%',
            overflow: 'hidden',
          },
          '& .MuiFormControlLabel-label': {
            width: '100%',
            overflow: 'hidden',
          },
        }}
        onChange={handleCheckboxChange}
        label={
          <>
            <div className="flex justify-between items-center gap-12">
              <div className="flex-1 pl-12 min-w-0">
                <div
                  className={` ${shouldUseNormalWeight ? 'text-[12px] font-br' : 'font-bb text-[16px] leading-16'}`}
                >
                  <span className="mr-5 truncate inline-block">
                    {address.firstname} {address.lastname}
                  </span>
                  <span className="truncate inline-block">{address.telephone}</span>
                </div>
                <div className="mt-6 text-[14px] leading-[20px] overflow-hidden">
                  {address.default === 1 && (
                    <span className="inline-block px-[4px] leading-[14px] text-[10px] bg-primary-purple text-white rounded-[8px] mr-4 flex-shrink-0">
                      {t('default')}
                    </span>
                  )}
                  <span className="text-[14px] leading-[13px] break-words">{address.address}</span>
                </div>
              </div>
              <Image
                src="/payment/edit@2x.png"
                alt="zeelool glasses"
                width={18}
                height={18}
                className="cursor-pointer"
                onClick={(e) => {
                  e.preventDefault();
                  // 打开编辑弹窗
                  onEditClick(address);
                }}
              />
            </div>
            {!!errorMsg && <div className="text-[#BC1B1B] mt-12 pl-12 text-[12px]">{errorMsg}</div>}
          </>
        }
      />
    </div>
  );
}
